var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"color":"red accent-2 white--text"}},[_vm._v(" "+_vm._s(_vm.$t("close"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }